<div class="d-flex" style="height: 50px;">
  <div class="align-self-center full-width"><ng-content></ng-content></div>
</div>
